import type { Connection, ConnectionListItem, ConnectionStatus } from "@/types";

interface HasStatus {
  status: ConnectionStatus;
}

/**
 * The badge shown for a connection. Status is the single source of truth (ADR-022): there is no
 * separate derived "health" — the status <i>is</i> the health. A failed `lastTestResult` is
 * point-in-time diagnostics surfaced on the detail view, not a badge driver.
 */
export function connectionBadgeLabel(c: HasStatus): string {
  switch (c.status) {
    case "PendingSetup": return "Setup incomplete";
    case "RequiresReauth": return "Reconnect needed";
    case "Connected": return "Connected";
    default: return c.status;
  }
}

/** Semantic badge class per DESIGN-GUIDELINES. */
export function connectionBadgeClass(c: HasStatus): string {
  switch (c.status) {
    case "PendingSetup": return "bg-warning";
    case "RequiresReauth": return "bg-danger";
    case "Connected": return "bg-success";
    default: return "bg-secondary";
  }
}

// A broken connection (RequiresReauth) is repaired in place via re-auth/rotate.
export function needsReconnect(c: Connection | ConnectionListItem): boolean {
  return c.status === "RequiresReauth";
}
